// src/index.ts
import { minimatch } from "minimatch";
function hasFeature(id, features) {
  if (!features || features.length === 0) {
    return false;
  }
  const cleaned = features.filter((c) => !!c).map((c) => c.trim());
  return cleaned.some((c) => minimatch(id, c));
}
export {
  hasFeature
};
